import { API_BASE_URL } from "../api/apiClient";

const PORTAL_BASE = "/api/v1/automap/dealer-portal";
const ADMIN_BASE = "/api/admin/automotive";

async function parseJson(res) {
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Error de solicitud.");
  return data;
}

export function fetchDealerLeads(dealerId, params = {}) {
  const qs = new URLSearchParams(params).toString();
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/leads${qs ? `?${qs}` : ""}`,
    { credentials: "include" }
  ).then(parseJson);
}

export function fetchDealerLead(dealerId, leadId) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/leads/${encodeURIComponent(leadId)}`,
    { credentials: "include" }
  ).then(parseJson);
}

export function updateDealerLeadStatus(dealerId, leadId, payload) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/leads/${encodeURIComponent(leadId)}/status`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  ).then(parseJson);
}

export function addDealerLeadNote(dealerId, leadId, body) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/leads/${encodeURIComponent(leadId)}/notes`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ body }),
    }
  ).then(parseJson);
}

export function recordDealerLeadWhatsappOpened(dealerId, leadId) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/leads/${encodeURIComponent(leadId)}/whatsapp-opened`,
    { method: "POST", credentials: "include" }
  ).then(parseJson);
}

export function updateDealerLeadOutcome(dealerId, leadId, payload) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/leads/${encodeURIComponent(leadId)}/outcome`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  ).then(parseJson);
}

export function updateDealerLeadQuality(dealerId, leadId, payload) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/leads/${encodeURIComponent(leadId)}/quality`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  ).then(parseJson);
}

export function updateDealerLeadAssignment(dealerId, leadId, payload) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/leads/${encodeURIComponent(leadId)}/assignment`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  ).then(parseJson);
}

export function fetchAdminLeads(params = {}) {
  const qs = new URLSearchParams(params).toString();
  return fetch(`${API_BASE_URL}${ADMIN_BASE}/leads${qs ? `?${qs}` : ""}`, {
    credentials: "include",
  }).then(parseJson);
}

export function fetchAdminLead(leadId) {
  return fetch(`${API_BASE_URL}${ADMIN_BASE}/leads/${encodeURIComponent(leadId)}`, {
    credentials: "include",
  }).then(parseJson);
}

export function reassignAdminLead(leadId, dealerId) {
  return fetch(`${API_BASE_URL}${ADMIN_BASE}/leads/${encodeURIComponent(leadId)}/reassign`, {
    method: "PATCH",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ dealerId }),
  }).then(parseJson);
}

export function openDealerWhatsapp(url, { dealerId, leadId, onOpened } = {}) {
  if (dealerId && leadId) {
    recordDealerLeadWhatsappOpened(dealerId, leadId)
      .then((data) => onOpened?.(data))
      .catch(() => {});
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
